import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { WAREHOUSES_FEATURE_KEY } from './keys';
import { warehousesReducer } from './reducers/warehouses.reducer';
import { WarehousesEffects } from './effects/warehouses.effects';

export function provideWarehousesStore(): EnvironmentProviders[] {
    return [provideState(WAREHOUSES_FEATURE_KEY, warehousesReducer), provideEffects(WarehousesEffects)];
}
